var React = require('react');

function PlayArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7.5 13 10.5 14h-21z","fill":"#fff","transform":"matrix(0 1 -1 0 27.5 3.5)"}));
}

PlayArrow.defaultProps = {"height":"22","viewBox":"0 0 15 22","width":"15"};

module.exports = PlayArrow;

PlayArrow.default = PlayArrow;
